import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {HttpModule, Http} from '@angular/http';
import {HttpClientModule} from '@angular/common/http'
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FormsModule} from '@angular/forms';

import {DropdownModule} from 'primeng/primeng';
import {ButtonModule} from 'primeng/primeng';
import {InputTextModule} from 'primeng/primeng';
import {CheckboxModule} from 'primeng/primeng';
import {TooltipModule} from 'primeng/primeng';
import {MessagesModule} from 'primeng/messages';
import {MessageModule} from 'primeng/message';
import {DialogModule} from 'primeng/primeng';

import {routing, appRoutingProviders} from './app.routing';

import {SettingsModule} from "./settings/settings.module";
import {UsersModule} from './users/users.module';
import {RolesModule} from './roles/roles.module';
import {SitesModule} from './sites/sites.module';
import {PagesModule} from './pages/pages.module';
import {PostsModule} from './posts/posts.module';
import {ThemesModule} from './themes/themes.module';
import {DatasModule} from './datas/datas.module';

import {AppComponent} from './app.component';
import {HomeComponent} from './home.component';
import {SignInComponent} from './signin.component';
import {SignUpComponent} from './signup.component';
import {ConfirmComponent} from './confirm.component';
import {ForgotComponent} from './forgot.component';
import {AuthGuard} from './auth/auth.guard';

import * as moment from 'moment';
import {AwsService} from "./aws.service";

moment.locale('es');

@NgModule({
    imports: [
        BrowserModule,
        HttpClientModule,
        HttpModule,
        BrowserAnimationsModule,
        FormsModule,
        routing,
        SettingsModule,
        UsersModule,
        RolesModule,
        SitesModule,
        PagesModule,
        PostsModule,
        ThemesModule,
        DatasModule,
        DropdownModule,
        ButtonModule,
        InputTextModule,
        CheckboxModule,
        TooltipModule,
        MessagesModule,
        MessageModule,
        DialogModule,
    ],
    declarations: [
        AppComponent,
        HomeComponent,
        SignInComponent,
        SignUpComponent,
        ConfirmComponent,
        ForgotComponent
    ],
    providers: [
        {provide: Window, useValue: window},
        Http,
        appRoutingProviders,
        AwsService,
        AuthGuard
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/app.module.ts